import type { CShopTranslations } from "./pl";

export const de: CShopTranslations = {
  cart: {
    title: "Warenkorb",
    empty:
      "Ihr Warenkorb ist leer. Bitte fügen Sie Produkte hinzu, um eine Bestellung aufzugeben.",
    productId: "Produkt-Nr.",
    productCategory: "Kategorie",
    productVariant: "Variante",
    productCount: "Menge",
    productPrice: "Preis (Brutto)",
    productPriceBeforePromotion: "Preis vor der Aktion (Brutto)",
    productSum: "Zwischensumme (Brutto)",
    variantColorAlt: "Farbmuster",
    summary: "Zusammenfassung",
    pricesIncludeVat: "Alle Beträge sind Bruttopreise (inkl. MwSt.).",
    sumCount: "Anzahl",
    sumProducts: "Produkte",
    sumDelivery: "Versand",
    discount: "Rabatt",
    total: "Gesamt (Brutto)",
    continueShopping: "Weiter einkaufen",
    gotoOrder: "Zur Bestellung",
    countLabel: "Menge",
    countDecrement: "Menge verringern",
    countIncrement: "Menge erhöhen",
    deleteItem: "Position aus dem Warenkorb entfernen",
    updateFailed: "Aktualisierung der Menge fehlgeschlagen. Bitte erneut versuchen.",
    deleteFailed: "Entfernen der Position fehlgeschlagen. Bitte erneut versuchen.",
    gotoOrderDisabledNoPayment: "Wählen Sie oben eine Zahlungsart, um zur Bestellung zu gelangen.",
    gotoOrderDisabledNoDelivery: "Wählen Sie oben eine Versandart, um zur Bestellung zu gelangen.",
    gotoOrderDisabledStock: "Eine Position überschreitet den verfügbaren Bestand - Menge anpassen, um fortzufahren.",
  },
  payment: {
    heading: "Zahlungsarten",
    emptyList:
      "Keine Zahlungsarten verfügbar — bitte wenden Sie sich an den Shop-Administrator.",
    changeFailed:
      "Die Zahlungsart konnte nicht geändert werden. Bitte erneut versuchen.",
    disabledOverMax:
      "Online-Zahlung ist für Bestellungen über {amount} {currency} nicht verfügbar. Bitte wählen Sie eine Banküberweisung.",
    gotoOrderDisabledOverMax:
      "Die gewählte Online-Zahlung ist für diesen Betrag nicht verfügbar - wählen Sie eine andere Option.",
  },
  delivery: {
    heading: "Versandarten",
    pickPaymentFirst: "Bitte wählen Sie zuerst eine Zahlungsart.",
    emptyList:
      "Keine Versandarten für die gewählte Zahlungsart — bitte wenden Sie sich an den Shop-Administrator.",
    changeFailed:
      "Die Versandart konnte nicht geändert werden. Bitte erneut versuchen.",
    free: "gratis",
  },
  discount: {
    heading: "Rabattcode",
    placeholder: "Rabattcode eingeben",
    apply: "Einlösen",
    remove: "Code entfernen",
    hint: "Der Rabatt gilt für Produkte, die nicht bereits reduziert sind.",
    active: "Code aktiv",
    statusEmpty: "Bitte geben Sie einen Rabattcode ein.",
    statusOk: "Code ist gültig.",
    statusNotExists: "Dieser Code existiert nicht.",
    statusExpired: "Dieser Code ist abgelaufen.",
    statusUsed: "Dieser Code wurde bereits eingelöst.",
    statusExhausted: "Dieser Code hat sein Nutzungslimit erreicht.",
    checkFailed: "Der Code konnte nicht überprüft werden. Bitte erneut versuchen.",
  },
  freeDelivery: {
    threshold:
      "Bestellen Sie für {price} {currency} oder mehr — Versand ist gratis.",
    is: "Sie erhalten kostenlosen Versand.",
    remaining: "Noch {remaining} {currency} bis zum kostenlosen Versand.",
  },
  order: {
    title: "Bestellung",
    sectionContact: "Kontaktdaten",
    sectionSendAddress: "Lieferadresse",
    sectionFvatData: "Rechnungsdaten",
    sectionCheckboxData: "Einwilligungen",
    labelEmail: "E-Mail",
    labelName: "Vorname",
    labelSurname: "Nachname",
    labelTelephone: "Telefon",
    labelCity: "Ort",
    labelPostCode: "PLZ",
    labelStreet: "Straße",
    labelNr: "Nr.",
    labelPass: "Passwort",
    labelPPass: "Passwort wiederholen",
    labelCompanyName: "Firmenname oder Vor- und Nachname",
    labelNip: "USt-IdNr.",
    labelCountry: "Land",
    labelBillingCountry: "Land (Rechnung)",
    countrySelectPlaceholder: "Land auswählen",
    fvatCheckbox: "Rechnung ausstellen",
    regulaminCheckbox:
      "Ich habe die [AGB]({regulamin_address}) von {host} gelesen und akzeptiere sie.",
    personalDataCheckbox:
      "Ich willige in die Verarbeitung meiner personenbezogenen Daten ein.",
    marketingCheckbox:
      "Ich willige in den elektronischen Marketing-Versand von {host} ein.",
    tabNewClient: "Neuer Kunde",
    tabJustOrder: "Bestellen ohne Registrierung",
    tabLogin: "Einloggen und bestellen",
    loginPromptTitle: "Anmelden",
    loginPromptHint:
      "Melden Sie sich an, um Ihre gespeicherten Daten zu verwenden. Nach dem Login kehren Sie hierher zurück.",
    loginLabelLogin: "E-Mail oder Benutzername",
    loginLabelPassword: "Passwort",
    loginSubmit: "Anmelden",
    loginSubmitBusy: "Wird angemeldet…",
    loginFailed: "Anmeldung fehlgeschlagen. Bitte Daten prüfen und erneut versuchen.",
    empty: "Ihr Warenkorb ist leer. Kehren Sie zum Shop zurück, um Produkte hinzuzufügen.",
    backToCard: "Zurück zum Warenkorb",
    submit: "Bestellung absenden",
    submitBusy: "Wird gesendet…",
    topError: "Bestellung konnte nicht aufgegeben werden. Bitte erneut versuchen.",
    validationRequired: 'Feld "{field}" ist erforderlich.',
    validationEmail: "Ungültige E-Mail-Adresse.",
    validationTelephone: "Ungültige Telefonnummer.",
    validationPassMinLength: "Passwort muss mindestens 8 Zeichen haben.",
    validationPassMismatch: "Passwörter stimmen nicht überein.",
    validationRegulamin: "Sie müssen die AGB akzeptieren.",
    validationPersonalData: "Sie müssen der Verarbeitung Ihrer personenbezogenen Daten zustimmen.",
    summaryHeading: "Ihre Bestellung",
  },
  inpost: {
    heading: "InPost-Paketstation",
    noneSelected: "Es wurde noch keine Paketstation ausgewählt.",
    gotoOrderRequired: "Bitte wählen Sie eine InPost-Paketstation, bevor Sie zur Kasse gehen.",
    change: "Paketstation ändern",
    remove: "Auswahl entfernen",
    select: "Paketstation auswählen",
    modalTitle: "InPost-Paketstation auswählen",
    modalClose: "Schließen",
    searchPlaceholder: "Nummer der Paketstation, Stadt, Straße oder Postleitzahl",
    searchAriaLabel: "Paketstation suchen",
    searchHint: "Geben Sie oben einen Suchbegriff ein oder klicken Sie auf einen Marker auf der Karte.",
    searchLoading: "Suche…",
    searchNoResults: "Keine Ergebnisse für die eingegebene Suchphrase.",
    nearest: "Nächstgelegene Paketstation finden",
    nearestBusy: "Standort wird ermittelt…",
    geolocationDenied: "Der Standortzugriff wurde verweigert. Bitte suchen Sie stattdessen nach Stadt.",
    geolocationUnsupported: "Ihr Browser unterstützt keine Geolokalisierung.",
    nearestNotFound: "In der Nähe des angegebenen Standorts wurde keine Paketstation gefunden.",
    loadFailed: "Paketstation-Daten konnten nicht geladen werden. Bitte erneut versuchen.",
    saveFailed: "Die ausgewählte Paketstation konnte nicht gespeichert werden. Bitte erneut versuchen.",
    mapFailed: "Die Karte konnte nicht geladen werden. Bitte nutzen Sie die Suche unten.",
    mapUnavailable: "Karte nicht verfügbar - bitte nutzen Sie die Suche unten.",
    confirm: "Auswahl bestätigen",
    cancel: "Abbrechen",
    listResultsAriaLabel: "Suchergebnisse für Paketstationen",
    selectedHeading: "Ausgewählte Paketstation",
    selectedClear: "Auswahl entfernen",
  },
  pickupPoint: {
    heading: "Abholpunkt",
    noneSelected: "Es wurde noch kein Abholpunkt ausgewählt.",
    gotoOrderRequired: "Bitte wählen Sie einen Abholpunkt, bevor Sie zur Kasse gehen.",
    change: "Punkt ändern",
    remove: "Auswahl entfernen",
    select: "Abholpunkt auswählen",
    modalTitle: "Abholpunkt auswählen",
    modalClose: "Schließen",
    searchPlaceholder: "Stadt, Name oder Postleitzahl eingeben",
    searchAriaLabel: "Abholpunkte filtern",
    emptyList: "Für diese Lieferoption sind keine Abholpunkte verfügbar.",
    noSearchMatch: "Kein Punkt entspricht der Suche.",
    loading: "Wird geladen…",
    loadFailed: "Die Liste der Abholpunkte konnte nicht geladen werden. Bitte erneut versuchen.",
    saveFailed: "Der ausgewählte Abholpunkt konnte nicht gespeichert werden. Bitte erneut versuchen.",
    confirm: "Auswahl bestätigen",
    cancel: "Abbrechen",
    navigate: "In Google Maps navigieren",
    openHoursHeading: "Öffnungszeiten",
    openHoursMonFri: "Mo-Fr",
    openHoursSat: "Samstag",
    openHoursSun: "Sonntag",
    openHoursClosed: "Geschlossen",
    openHoursAllDay: "24 Stunden",
    listResultsAriaLabel: "Liste der verfügbaren Abholpunkte",
    selectedClear: "Auswahl entfernen",
  },
  orderComplete: {
    heading: "Ihre Bestellung {nr} wurde entgegengenommen. Vielen Dank!",
    toPaySum: "Bestellsumme: {amount}",
    orderNr: "Ihre Bestellnummer lautet {nr}",
    paidBanner: "Die Bestellung wurde bezahlt.",
    yourOrders: "Ihre Bestellungen",
    goToPayment: "Jetzt online bezahlen",
    notFound: "Bestellung nicht gefunden. Prüfen Sie den Link aus der E-Mail oder melden Sie sich an und öffnen Sie Ihre Bestellliste.",
    paymentInfoTransfer: "Die Zahlung kann auf folgendes Bankkonto erfolgen:",
    paymentInfoOnline: "Die Zahlung kann über unser Online-Zahlungssystem erfolgen",
    paymentInfoOnlineWithAccount: "Die Zahlung kann über unser Online-Zahlungssystem oder per Überweisung auf folgendes Bankkonto erfolgen:",
    paymentInfoCash: "Die Zahlung kann bar an den Verkaufsstellen erfolgen:",
  },
  formatPrice: (value: number, currency: string): string => {
    const rounded = (Math.round(value * 100) / 100).toFixed(2);
    return currency ? `${rounded} ${currency}` : rounded;
  },
};
